import ApiService from "../api/api.service";

class BaseService {

    getLanguages(data) {
        return ApiService.postData("settings/languages", data);
    }

    getHomeContent(data) {
        return ApiService.postData("content/home", data);
    }

    getImage(url) {
        return ApiService.getImage(url)
            .then((response) => {
                return response
            })
            .catch((err) => {
                return [];
            });
    }

    getData(url) {
        return ApiService.getData(url)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return [];
            });
    }


    getContent(data) {
        return ApiService.getData("content/" + data.page, data)
            .then((res) => {

                if ("cookies_settings" === data.page) {

                }

                return res.data;
            });
    }

    getStrategy(id) {
        return ApiService.getData("content/marketplace/" + id)
            .then((res) => {
                return res.data;
            });
    }

    getStrategies(filter) {
        return ApiService.postData("content/marketplace/", { filter })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return [];
            });
    }

    sendContact(data) {
        return ApiService.postData("request_contact", data);
    }

    sendData(page, data) {
        return ApiService.postData("content/" + page, data)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return [];
            });
    }

    post(page, data) {
        return ApiService.postData(page, data)
            .then((res) => {
                return res.data;
            })
            .catch((error) => {
                if (error.response) {
                    throw new Error('Error:' + error.response.status + ", " + error.response.data.message);
                } else if (error.request) {
                    throw new Error(error.request);
                } else {
                    throw new Error(error.message);
                }
            });
    }

    sendPost(page, data, promis = true) {

        if (!promis) return ApiService.postData(page, data);

        return ApiService.postData(page, data)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return [];
            });
    }

    getSubscriptionid(){
        return ApiService.getData("/user");
    }

    getPlans(data) {
        return ApiService.postData("content/plans", data);
    }

    getPlansDetails(data) {
        return ApiService.postData("content/plans_details", data);
    }

    validateToken(data) {
        return ApiService.postData("validate_token", data);
    }

    objectToQueryString(obj) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p) && obj[p] !== "") {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    parseErrors(error) {
        return ApiService.parseErrors(error)
    }
}
const baseService = new BaseService();

export default baseService;
